// Types
import { Picture } from '../../picture/objects/picture';
import { RecommendedAccommodationState } from '../objects/recommendedAccommodationState';
// Action Types
import {
    ADD_PREFERENCES,
    DELETE_CUSTOM_PICTURE,
    MOVE_DOWN_COLUMN,
    MOVE_UP_COLUMN,
    RecommendedAccommodationActionTypes,
    RESET_FILTERS,
    RESET_RECOMMENDED_ACCOMMODATION,
    RESIZE_COLUMN,
    SET_EDIT,
    SET_ERRORS,
    SET_EXPORT_TYPE,
    SET_LIMIT,
    SET_LIST,
    SET_LIST_ITEM_BLACKLIST,
    SET_LIST_ITEM_FAVORITE,
    SET_ORDER_BY,
    SET_PAGE,
    SET_PREFERENCES as SET_RECOMMENDED_ACCOMMODATION_PREFERENCES,
    SET_RECOMMENDED_ACCOMMODATION,
    SET_RECOMMENDED_ACCOMMODATION_SELECTED,
    SET_RUNNING,
    SET_SEARCH,
    TOGGLE_COLUMN,
    TOGGLE_EXPORT,
    TOGGLE_EXPORT_FULL,
    TOGGLE_FILTERS,
    TOGGLE_LIST_COMFIRM_ACTION_IS_OPEN,
    TOGGLE_PICTURE_ACTIVATED,
    TOGGLE_REFRESH,
    UPDATE_FILTER_CITY,
    UPDATE_FILTER_COUNTRY,
    UPDATE_FILTER_IS_ALL_ACCOMMODATION,
    UPDATE_FILTER_NAME,
    UPDATE_FILTER_TAG,
    UPDATE_FILTER_ALLOWED_CMS,
    UPDATE_FILTER_STARS,
    UPDATE_LIST_ITEM_BLACKLIST,
    UPDATE_LIST_ITEM_FAVORITE,
    UPDATE_PICTURE_ORDER,
    UPDATE_REMARK_FAVORITE,
    SET_COLUMNS,
    SET_ACCOMMODATION_TAGS,
    UPDATE_ALLOWED_CMS,
    SET_AUTHORIZE_TO_CMS
} from './actionTypes';
import { ProfileActionTypes, SET_PREFERENCES } from '../../profile/redux/actionTypes';
import { applyColumnResize } from '../../utils/list/utils/columnResize';
import { setRecommendedAccommodationPreference, DEFAULT_RECOMMENDED_ACCOMMODATION_COLUMNS } from '../utils/setRecommendedAccommodationPreference';
import { ADD_CUSTOM_PICTURES, PictureActionTypes, SET_PICTURE } from '../../picture/redux/actionTypes';
import { RecommendedAccommodationReduced } from '../objects/recommendedAccommodationReduced';
import { AccommodationTag } from '../../accommodationTag/objects/accommodationTag';

const initialState: RecommendedAccommodationState = {
    columns: DEFAULT_RECOMMENDED_ACCOMMODATION_COLUMNS,
    count: 0,
    custom_pictures: [],
    custom_pictures_order: [],
    export_full: false,
    export_list: false,
    export_type: 'CSV',
    filter_city: '',
    filter_country: null,
    filter_name: '',
    filter_tags: [],
    filter_allowed_cms: [],
    filter_stars: [],
    filter_open: false,
    giata_pictures: [],
    is_all_accommodation: 'all',
    limit: 25,
    list: null,
    list_confirm_action_is_open: false,
    order: 'asc',
    order_by: '-created_date',
    page: 0,
    preferences: [],
    recommended_accommodation: null,
    recommended_accommodation_selected: [],
    remark_favorite: '',
    refresh: false,
    running: false,
    search: '',
    accommodation_tags: [],
    allowed_cms: [],
    authorize_to_cms: false
};

export default (state: RecommendedAccommodationState = initialState, action: RecommendedAccommodationActionTypes | ProfileActionTypes | PictureActionTypes): RecommendedAccommodationState => {
    switch (action.type) {
        case ADD_PREFERENCES: {
            return { ...state, preferences: [...state.preferences, ...action.payload] };
        }
        case ADD_CUSTOM_PICTURES: {
            return { ...state, custom_pictures: [...state.custom_pictures, ...action.payload] };
        }
        case DELETE_CUSTOM_PICTURE: {
            const custom_pictures = [...state.custom_pictures];
            custom_pictures.splice(action.payload, 1);
            return { ...state, custom_pictures: custom_pictures };
        }
        case MOVE_DOWN_COLUMN: {
            const columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            const column = { ...columns[action.payload + 1] };
            columns[action.payload + 1] = columns[action.payload];
            columns[action.payload + 1].last_updated = true;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case MOVE_UP_COLUMN: {
            const columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            const column = { ...columns[action.payload - 1] };
            columns[action.payload - 1] = columns[action.payload];
            columns[action.payload - 1].last_updated = true;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case RESET_FILTERS: {
            return {
                ...state,
                filter_city: '',
                filter_country: null,
                filter_name: '',
                filter_tags: [],
                filter_allowed_cms: [],
                filter_stars: [],
                page: 0
            };
        }
        case RESET_RECOMMENDED_ACCOMMODATION: {
            return { ...state };
        }
        case SET_EDIT: {
            if (state.recommended_accommodation !== null) {
                const custom_pictures: Picture[] = [];
                const giata_pictures: (Picture & {activated: boolean})[] = [];
                if (state.recommended_accommodation.custom_pictures !== null && state.recommended_accommodation.custom_pictures.length > 0) {
                    state.recommended_accommodation.custom_pictures.map(custom_picture => {
                        let activated = false;
                        if (state.recommended_accommodation?.pictures !== null) {
                            state.recommended_accommodation?.pictures.map(picture => {
                                if (custom_picture.id === picture.id) {
                                    activated = true;
                                }
                            });
                        }
                        if (!activated) {
                            custom_pictures.push({ ...custom_picture });
                        }
                    });
                }
                if (state.recommended_accommodation.pictures !== null) {
                    state.recommended_accommodation.pictures.map(picture => {
                        let activated = state.recommended_accommodation?.custom_pictures === null || state.recommended_accommodation?.custom_pictures.length === 0;
                        if (state.recommended_accommodation?.custom_pictures !== null && (state.recommended_accommodation?.custom_pictures.length ?? 0) > 0) {
                            state.recommended_accommodation?.custom_pictures.map(custom_picture => {
                                if (custom_picture.id === picture.id) {
                                    activated = true;
                                }
                            });
                        }
                        giata_pictures.push({ ...picture, activated: state.recommended_accommodation?.ignore_giata_pictures ? false : activated });
                    });
                }
                return {
                    ...state,
                    edit: action.payload,
                    custom_pictures: custom_pictures,
                    custom_pictures_order: state.recommended_accommodation.custom_pictures !== null && state.recommended_accommodation.custom_pictures.length > 0 ? [...state.recommended_accommodation.custom_pictures] : state.recommended_accommodation.pictures !== null && state.recommended_accommodation.pictures.length > 0 ? [...state.recommended_accommodation.pictures] : [],
                    giata_pictures: giata_pictures,
                    remark_favorite: state.recommended_accommodation.remark_favorite !== null ? state.recommended_accommodation.remark_favorite : ''
                };
            }
            return state;
        }
        case SET_ERRORS: {
            const errors = action.payload;
            const new_state: RecommendedAccommodationState = { ...state };
            errors.map(error => {
                if (error.subkey !== undefined && error.subkey_index !== undefined) {
                    const property = [...new_state[error.key]];
                    const sub_property = { ...property[error.subkey_index] };
                    sub_property[error.subkey] = error.error;
                    property[error.subkey_index] = sub_property;
                    new_state[error.key] = property;
                } else {
                    new_state[error.key] = error.error;
                }
            });
            return { ...new_state };
        }
        case SET_EXPORT_TYPE: {
            return { ...state, export_type: action.payload };
        }
        case SET_LIMIT: {
            return { ...state, list: null, limit: action.payload };
        }
        case SET_LIST: {
            const { count, results } = action.payload;
            return { ...state, count: count, list: results as RecommendedAccommodationReduced[], recommended_accommodation_selected:[], running: false };
        }
        case SET_ORDER_BY: {
            return { ...state, list: null, order_by: action.payload, order: state.order_by === action.payload && state.order === 'asc' ? 'desc': 'asc' };
        }
        case SET_PAGE: {
            return { ...state, list: null, page: action.payload };
        }
        case SET_PICTURE: {
            if (action.payload !== true && action.payload !== false) {
                const custom_pictures = [...state.custom_pictures];
                for (let i = 0; i < custom_pictures.length; i++) {
                    if (custom_pictures[i].id === action.payload.id) {
                        custom_pictures[i] = { ...action.payload };
                        break;
                    }
                }
                return { ...state, custom_pictures: custom_pictures };
            }
            return state;
        }
        case SET_PREFERENCES: {
            const { columns, preferences, order_by, order } = setRecommendedAccommodationPreference(action.payload, state.columns);
            return { ...state, columns, preferences, order_by, order };
        }
        case SET_RECOMMENDED_ACCOMMODATION_PREFERENCES: {
            return { ...state, preferences: action.payload };
        }
        case SET_RECOMMENDED_ACCOMMODATION: {
            let tags: AccommodationTag[] = [];
            if(action.payload.tags.length > 0 && typeof action.payload.tags[0] !== 'object') {
                tags = (action.payload.tags as unknown as number[]).map((tag: number) => (state.accommodation_tags[tag]));
            } else {
                tags = action.payload.tags;
            }
            return {...state, recommended_accommodation: {...action.payload, phone_numbers: action.payload.phone_numbers ?? [], tags}};
        }
        case SET_RECOMMENDED_ACCOMMODATION_SELECTED: {
            return { ...state, recommended_accommodation_selected: action.payload };
        }
        case SET_RUNNING: {
            return { ...state, running: action.payload };
        }
        case SET_SEARCH: {
            return { ...state, list: null, search: action.payload, page: 0 };
        }
        case TOGGLE_COLUMN: {
            const columns = [...state.columns];
            const column = { ...columns[action.payload] };
            column.checked = !column.checked;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case TOGGLE_EXPORT: {
            return { ...state, export_list: action.payload };
        }
        case TOGGLE_EXPORT_FULL: {
            return { ...state, export_full: !state.export_full };
        }
        case TOGGLE_FILTERS: {
            return { ...state, filter_open: !state.filter_open };
        }
        case TOGGLE_LIST_COMFIRM_ACTION_IS_OPEN:{
            return { ...state, list_confirm_action_is_open: action.payload };
        }
        case TOGGLE_PICTURE_ACTIVATED: {
            const giata_pictures = [...state.giata_pictures];
            const picture = { ...giata_pictures[action.payload] };
            picture.activated = !picture.activated;
            giata_pictures[action.payload] = picture;
            return { ...state, giata_pictures: giata_pictures };
        }
        case TOGGLE_REFRESH: {
            return { ...state, refresh: !state.refresh };
        }
        case UPDATE_FILTER_CITY: {
            return { ...state, filter_city: action.payload, page: 0 };
        }
        case UPDATE_FILTER_COUNTRY: {
            return { ...state, filter_country: action.payload, page: 0 };
        }
        case UPDATE_FILTER_IS_ALL_ACCOMMODATION: {
            return { ...state, is_all_accommodation: action.payload, page: 0 };
        }
        case UPDATE_FILTER_NAME: {
            return { ...state, filter_name: action.payload, page: 0 };
        }
        case UPDATE_FILTER_TAG: {
            return { ...state, filter_tags: action.payload, page: 0 };
        }
        case UPDATE_FILTER_ALLOWED_CMS: {
            return { ...state, filter_allowed_cms: action.payload, page: 0 };
        }
        case UPDATE_FILTER_STARS: {
            return { ...state, filter_stars: action.payload, page: 0 };
        }
        case UPDATE_LIST_ITEM_BLACKLIST: {
            if (state.list !== null) {
                const list = [...state.list];
                for (let i = 0; i < list.length; i++) {
                    if (list[i].owner_id === action.payload) {
                        list[i].blacklist = !list[i].blacklist;
                        if (list[i].blacklist) {
                            list[i].favorite = false;
                        }
                        break;
                    }
                }
                return { ...state, list: list,  recommended_accommodation_selected:[] };
            }
            return state;
        }
        case UPDATE_LIST_ITEM_FAVORITE: {
            if (state.list !== null) {
                const list = [...state.list];
                for (let i = 0; i < list.length; i++) {
                    if (list[i].owner_id === action.payload) {
                        list[i].favorite = !list[i].favorite;
                        if (list[i].favorite) {
                            list[i].blacklist = false;
                        }
                        break;
                    }
                }
                return { ...state, list: list,  recommended_accommodation_selected:[] };
            }
            return state;
        }
        case SET_LIST_ITEM_FAVORITE: {
            if (state.list !== null) {
                const list = [...state.list];
                for (let i = 0; i < list.length; i++) {
                    if (list[i].owner_id === action.payload.index) {
                        list[i].favorite = action.payload.action;
                        if (action.payload.action) {
                            list[i].blacklist = false;
                        }
                        break;
                    }
                }
                return { ...state, list: list,  recommended_accommodation_selected:[] };
            }
            return state;
        }
        case SET_LIST_ITEM_BLACKLIST: {
            if (state.list !== null) {
                const list = [...state.list];
                for (let i = 0; i < list.length; i++) {
                    if (list[i].owner_id === action.payload.index) {
                        list[i].blacklist = action.payload.action;
                        if (action.payload.action) {
                            list[i].favorite = false;
                        }
                        break;
                    }
                }
                return { ...state, list: list,  recommended_accommodation_selected:[] };
            }
            return state;
        }
        case UPDATE_PICTURE_ORDER: {
            const { drag_index, hover_index } = action.payload;
            const custom_pictures_order = [...state.custom_pictures_order];
            custom_pictures_order.splice(drag_index, 1);
            custom_pictures_order.splice(hover_index, 0, state.custom_pictures_order[drag_index]);
            return { ...state, custom_pictures_order: custom_pictures_order };
        }
        case UPDATE_REMARK_FAVORITE: {
            return { ...state, remark_favorite: action.payload };
        }
        case SET_COLUMNS: {
            return { ...state, columns: action.payload };
        }
        case RESIZE_COLUMN: {
            return { ...state, columns: applyColumnResize(state.columns, action.payload) };
        }
        case SET_ACCOMMODATION_TAGS: {
            return { ...state, accommodation_tags: action.payload };
        }
        case UPDATE_ALLOWED_CMS: {
            return { ...state, allowed_cms: action.payload };
        }
        case SET_AUTHORIZE_TO_CMS: {
            return { ...state, authorize_to_cms: action.payload };
        }
        default:
            return state;
    }
};